/* Server-formatted money; no independent currency or discount calculations. */
(() => {
  if (customElements.get('gyroor-sku-save-badge')) return;
  class GyroorSkuSaveBadge extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse(this.querySelector('[data-badge-variants]').textContent); }
      catch { this.hidden = true; return; }
      this.card = this.closest('.product-card');
      this.form = document.getElementById(this.dataset.formId || this.closest('media-gallery')?.getAttribute('form') || '');
      this.onChange = (event) => {
        if (event.target.matches('[name="id"]')) this.update(event.target.value);
      };
      this.onOptionChange = (event) => {
        if (!event.target.matches('[name="id"]') && event.target.closest('variant-picker')) this.hidden = true;
      };
      this.owner = this.card || this.form;
      this.owner?.addEventListener('change', this.onChange);
      this.info = this.card || (this.form && document.querySelector(`product-info[form="${CSS.escape(this.form.id)}"]`));
      this.info?.addEventListener('change', this.onOptionChange);
      this.update(this.dataset.variantId);
    }
    disconnectedCallback() {
      this.owner?.removeEventListener('change', this.onChange);
      this.info?.removeEventListener('change', this.onOptionChange);
    }
    update(id) {
      const variant = this.variants[String(id)];
      const saving = variant && Number(variant.compare_at_price) - Number(variant.price);
      this.hidden = !(Math.round(saving / 100) > 0);
      if (this.hidden) return;
      this.dataset.variantId = String(id);
      // Currency apps may wrap server money strings in a span, including JSON values.
      const label = new DOMParser().parseFromString(variant.label, 'text/html').body.textContent;
      this.querySelector('[data-save-label]').textContent = label.replace(/\s+/g, ' ').trim();
    }
  }
  customElements.define('gyroor-sku-save-badge', GyroorSkuSaveBadge);
})();
